module.exports = __webpack_public_path__ + "e4f70ab2c03b8713fd7d3faaa84de547.svg";